import React, { ErrorInfo, ReactNode } from 'react';
import logger from '../../lib/logger';

interface Props {
  children: ReactNode;
  fallback: (props: { resetErrorBoundary: () => void }) => ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    logger.error('Felgräns fångade ett fel', {
      felmeddelande: error.message,
      komponentstack: errorInfo.componentStack?.slice(0, 200), // Begränsa för att undvika känslig information
    });
  }

  resetErrorBoundary = (): void => {
    this.setState({ hasError: false, error: null });
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback({ resetErrorBoundary: this.resetErrorBoundary });
    }

    return this.props.children;
  }
}

export default ErrorBoundary;